var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Note") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6964844,4.01242617 L12.4897266,0.805238672 C11.9710938,0.289699609 11.2707031,0 10.5445313,0 L2.75,0 C1.23105469,0 0,1.23105469 0,2.75 L0.000279296875,19.25 C0.000279296875,20.7685156 1.23133398,22 2.7502793,22 L13.75,22 C15.2625,22 16.5,20.7625 16.5,19.25 L16.5,5.95547305 C16.5,5.22930117 16.2121094,4.52891055 15.6964844,4.01242617 Z M14.4375,19.2500043 C14.4375,19.6296762 14.1296719,19.9375043 13.75,19.9375043 L2.75085938,19.9375043 C2.37110156,19.9375043 2.06335937,19.6296762 2.06335937,19.2500043 L2.0625,2.75559023 C2.0625,2.37591836 2.37032812,2.06809023 2.75,2.06809023 L9.625,2.06809023 L9.625,5.5000043 C9.625,6.25926211 10.2407422,6.8750043 11,6.8750043 L14.3988281,6.8750043 L14.3988281,19.2500043 L14.4375,19.2500043 Z M4.125,12.0312543 C4.125,12.6027387 4.5890625,13.0625043 5.15625,13.0625043 L11.34375,13.0625043 C11.9152344,13.0625043 12.375,12.6027387 12.375,12.0312543 C12.375,11.4597699 11.9152344,11.0000043 11.34375,11.0000043 L5.15625,11.0000043 C4.5890625,11.0000043 4.125,11.4640668 4.125,12.0312543 Z M11.34375,15.1250043 L5.15625,15.1250043 C4.5890625,15.1250043 4.125,15.5890668 4.125,16.1562543 C4.125,16.7234418 4.58691406,17.1875043 5.15625,17.1875043 L11.34375,17.1875043 C11.9130859,17.1875043 12.375,16.7255902 12.375,16.1562543 C12.375,15.5869184 11.9152344,15.1250043 11.34375,15.1250043 Z",
    id: "note"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/outline/note_24px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-note",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#note"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Note",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#note"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-note)",
    fill: "#34436D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -1.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 125,
    height: 50
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.7eae657b.svg";
export { ForwardRef as ReactComponent };